import React, { useContext, useState, useEffect, useMemo } from 'react'
import classNames from 'classnames'
import { CartContext } from '@/store/cart'
import { SimpleSlider } from '@saatva-bits/pattern-library.components.simple-slider'
import { useBreakpoints } from '@saatva-bits/pattern-library.hooks.use-breakpoints'
import ProductTile from './ProductTile'
import styles from './styles.module.scss'
import { pushCartAtcClick, pushRecoStripVisible } from '@/utils/analytics'
import { useProductDetailModal } from '@saatva-bits/pattern-library.components.product-detail-modal/dist/store/modal-context'

const RecommendedProducts = () => {
    const {
        recommendedProducts,
        setSliderInitialLoad,
    } = useContext(CartContext)
    const { setIsOpen: setDetailModalIsOpen, setSelectedProduct } = useProductDetailModal()
    const { isMobile, isTablet } = useBreakpoints('mobile', 435)
    const [shownSize, setShownSize] = useState(2)
    const [index, setIndex] = useState(0)

    const openDetailModal = (product, productListPosition) => {
        setSelectedProduct(product)
        setDetailModalIsOpen(true)
        pushCartAtcClick(product, productListPosition)
    }

    useEffect(() => {
        if (isMobile) {
            setShownSize(2)
        } else if (isTablet) {
            setShownSize(3)
        } else {
            // default desktop
            setShownSize(4)
        }
    }, [isMobile, isTablet, recommendedProducts])

    const listContainerClasses = classNames(styles.listContainer)
    const sliderContainerClasses = classNames(styles.sliderContainer)
    const sliderItemsContainerClasses = classNames(styles.sliderItemsContainer)
    const sliderClasses = classNames(styles.slider)
    const childClasses = classNames(styles.itemContainer)

    // Hack to force the first pushRecoStripVisible on Load
    const InitialSliderLoad = () => {
        useEffect(() => {
            setSliderInitialLoad(true)
        }, [])

        return null
    }

    // Index in onchange function will only have valid value
    // when arrows are clicked, when dots are clicked value
    // is undefined. We need to manually find it after is
    // added to the DOM.
    const asyncPushRecoStrip = () => {
        // Will extract the text of: slide page 3 of 4
        const liveregion = document.querySelectorAll(`.liveregion`)[0].textContent
        // Will match the first number in: slide page 3 of 4
        const regex = /(\d+) of \d+/
        const found = liveregion.match(regex)
        const currentPage = found && found[1] ? found[1] : null
        
        if (currentPage) {
            pushRecoStripVisible(currentPage)
        }
    }

    const sliderChange = () => {
        setTimeout(asyncPushRecoStrip, 250)
    }

    const productList = useMemo(() => {
        return recommendedProducts
    }, [recommendedProducts])

    return (
        <div className={listContainerClasses}>
            <div className={sliderContainerClasses}>
                {productList?.length > 0 &&
                    <>
                        <SimpleSlider
                            className={sliderClasses}
                            sliderClassName={sliderItemsContainerClasses}
                            childClass={childClasses}
                            shownSize={shownSize}
                            onChangeOffset={shownSize}
                            index={index}
                            setIndex={(index) => setIndex(index)}
                            sliderLabel={'Recommended Products'}
                            peekable={false}
                            infinite={false}
                            showButtons
                            pageDots
                            onChange={sliderChange}
                            isCart
                        >
                            {productList?.map((product, i) => (
                                <ProductTile
                                    key={`product-tile-${product.sku}`}
                                    product={product}
                                    onClick={openDetailModal}
                                    index={i}
                                />
                            ))}
                        </SimpleSlider>
                        <InitialSliderLoad/>
                    </>
                }
            </div>
        </div>
    )
}

export default RecommendedProducts
